import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { competencyModelAPI } from '@/providers/apis/competency-model/competency-model';
import {
  DEPTH_FILTER,
  COMPETENCY_TREE_GROUP,
  DEMO_USER_ACCESS_CATEGORIES_LIST,
} from '@/utils/constants';
import { sessionService } from '@/providers/services/auth/session';
import { CompetencyModel } from '@/models/taxonomy/competency';
import UploadModel from './upload-model/upload-model';
import FileVersion from './file-version/file-version';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';

@Component({
  name: 'add-competency',
  components: {
    'upload-model': UploadModel,
    'file-version': FileVersion,
  },
})
export default class AddCompetency extends Vue {
  public errorMessage: string | undefined;
  // ---------------------------------------------------------------
  // Properties
  private listBy: any = '';
  private offset: number = 0;
  private limit: number = 20;
  private subjectCode: any = null;
  private totalItems: any;
  private cardName?: string;
  private selectedCompetency: any = null;
  private isLoading: boolean = false;
  private competencyList?: CompetencyModel[] | any = [];
  private isShowPopup: boolean = false;
  private session: any = null;
  private classificationList: any = [];
  private currentPage: number = 1;

  public loadContent(page: number) {
    this.currentPage = page;
    const items = this.limit * this.currentPage;
    if (items >= this.competencyList.length) {
      this.offset = this.currentPage * this.limit - this.competencyList.length;
      this.limit = 20;
      this.loadCompetencyList();
    }
  }

  private isPermissionAvailable() {
    return this.session!.permissions.indexOf('ADD_COMPETENCY_MODEL') !== -1;
  }

  // Actions
  private closePopup(show: boolean = false) {
    this.isShowPopup = show;
    // this.loadCompetencyList();
  }

  // Hooks
  private created() {
    this.session = sessionService.getSession();
    if (this.isPermissionAvailable()) {
      this.loadCompetencyList();
      this.fetchClassifications();
    }
  }

  private mounted() {
    // const compList = document.querySelector('#competency-list');
    // if (compList !== null) {
    //   compList.addEventListener('scroll', (e) => {
    //   if (compList.scrollTop + compList.clientHeight >= compList.scrollHeight) {
    //     this.offset = this.offset + this.limit;
    //     this.loadCompetencyList();
    //   }
    // });
    // }
  }

  // Methods
  private async loadCompetencyList() {
    let userId = '';
    let tenantId = '';

    if (this.listBy === 'public') {
      userId = '';
      tenantId = '';
    } else if (this.listBy === 'only me') {
      userId = this.session.user_id;
      tenantId = '';
    } else if (this.listBy === 'my orginazation') {
      userId = '';
      tenantId = this.session.tenant.tenant_id;
    }
    this.competencyList = [];
    return competencyModelAPI
      .fetchCompetencyModelList(this.offset, this.limit, userId, tenantId, this.subjectCode)
      .then((competencyList: any) => {
        if (competencyList.length === 0) {
          competencyList = undefined;
        } else {
          this.totalItems = competencyList.totalCount;
          for (const item of competencyList.compModel) {
            if (item.status === 'in-review') {
              item.display_status = 'In Review';
            } else if (item.status === 'error') {
              item.display_status = 'Errors';
            } else if (item.status === 'published') {
              item.display_status = 'Published';
            } else if (item.status === 'unpublished') {
              item.display_status = 'Unpublished';
            } else if (item.status === 'in-progress') {
              item.display_status = 'In Progress';
            } else if (item.status === 'pending') {
              item.display_status = 'Pending';
            } else if (item.status === 'pending') {
              item.display_status = 'Pending';
            } else if (item.status === 'waiting_for_approval') {
              item.display_status = 'Approval Needed';
            }
            this.competencyList.push(item);
          }
        }
      });
  }

  private openModel() {
    this.cardName = 'upload-model';
    this.isShowPopup = true;
  }

  private openFileVersion() {
    this.cardName = 'file-version';
    this.isShowPopup = true;
  }

  private refreshListBySubject(value: any) {
    this.competencyList = [];
    this.subjectCode = value;
    this.loadCompetencyList();
  }


  private refreshList(value: any) {
    this.competencyList = [];
    this.listBy = value;
    this.loadCompetencyList();
  }
  private resetFilters() {
    this.listBy = '';
    this.subjectCode = null;
  }

  private deleteComp(id: any) {
    competencyModelAPI.delete(id).then((res) => {
      this.loadCompetencyList();
    });
  }

  private onSelectCompetency(competency: any) {
    this.isShowPopup = true;
    this.cardName = 'file-version';
    this.selectedCompetency = competency;
  }

  private ingest(competency: any) {
    competencyModelAPI.ingestFileVersionById(competency.fileVersionId).then((res) => {
      this.loadCompetencyList();
    });
  }

  private fetchClassifications() {

    return taxonomyAPI.fetchTaxonomyClassifications()
      .then((classifications) => {
        // this.classificationList = classifications;

        classifications.forEach((item: any) => {
          taxonomyAPI.fetchTaxonomySubjects(item.id).then((subjects) => {

            const obj: any = { id: '', code: '', title: '', subjects: [] };
            obj.id = item.id;
            obj.code = item.code;
            obj.title = item.title;
            obj.subjects = subjects;
            this.classificationList.push(obj);
          });
        });
      });
  }

}
